// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlayCircleTwoToneSvg from "@fishx/icons-svg/es/asn/PlayCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var PlayCircleTwoTone = function PlayCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleTwoToneSvg
  }));
};

PlayCircleTwoTone.displayName = 'PlayCircleTwoTone';
export default React.forwardRef(PlayCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlayCircleTwoTone.js
// module id = 3801
// module chunks = 0